"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconClassName = getIconClassName;
var merge_styles_1 = require("@fluentui/merge-styles");
var icons_1 = require("./icons");
var defaultIconStyles = {
    display: 'inline-block',
};
/**
 * Gets an icon classname. You should be able to add this classname to an I tag with no
 * additional classnames, and render the icon.
 *
 * @public
 */
function getIconClassName(name) {
    var className = '';
    var icon = (0, icons_1.getIcon)(name);
    if (icon) {
        className = (0, merge_styles_1.mergeStyles)(icon.subset.className, defaultIconStyles, {
            selectors: {
                '::before': {
                    content: "\"".concat(icon.code, "\""),
                },
            },
        });
    }
    return className;
}
//# sourceMappingURL=getIconClassName.js.map